module.exports = __webpack_public_path__ + "static/img/zhengshu4.d705fd82.webp";